import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Button } from '@cancercentrum/rcc-bootstrap';
import { incaAccessor } from '@cancercentrum/inca';
import { AjaxErrorAlert } from '../AjaxErrorAlert';
export const ExecuteActionResult = (props)=>{
    const { title, isFinished, stateTransitionResult } = props;
    const [transitionResult, error] = stateTransitionResult;
    const inca = incaAccessor();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            error && /*#__PURE__*/ _jsx(AjaxErrorAlert, {
                error: error
            }),
            /*#__PURE__*/ _jsxs(Alert, {
                bsStyle: "success",
                children: [
                    /*#__PURE__*/ _jsx("h4", {
                        children: title
                    }),
                    !isFinished && /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            bsStyle: "link",
                            className: "ps-0",
                            onClick: ()=>inca.form.reload(),
                            children: "Klicka här för att ladda om ärendet."
                        })
                    }),
                    transitionResult.registerRecordId && /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            bsStyle: "link",
                            className: "ps-0",
                            onClick: ()=>inca.overview.openRegisterRecord(transitionResult.registerRecordId),
                            children: "Klicka här för att ladda registerposten."
                        })
                    }),
                    transitionResult.documentId && /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            bsStyle: "link",
                            className: "ps-0",
                            onClick: ()=>inca.overview.openDocument(transitionResult.documentId),
                            children: "Klicka här för att ladda originalhandlingen."
                        })
                    })
                ]
            })
        ]
    });
};
